export const isValidHttpUrl = (str: string): boolean => {
	let givenURL: URL;
	try {
		givenURL = new URL(str);
	} catch (error) {
		return false;
	}
	return givenURL.protocol === 'http:' || givenURL.protocol === 'https:';
};
